(function () {
  'use strict';

  var SWIPER_DRAG = {
    simulateTouch: true,
    allowTouchMove: true,
    touchStartPreventDefault: false,
    grabCursor: true,
    watchOverflow: false
  };

  function preloadEssentialImages(root) {
    root.querySelectorAll('.ess-section__image').forEach(function (img) {
      img.loading = 'eager';
      if (img.complete) return;
      var src = img.currentSrc || img.src;
      if (src) {
        var loader = new Image();
        loader.src = src;
      }
      if (img.decode) {
        img.decode().catch(function () {});
      }
    });
  }

  function initEssentialsWithinReach(root) {
    if (!root || root.dataset.essInit === 'true') return;

    var swiperEl = root.querySelector('[data-ess-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    root.dataset.essInit = 'true';

    var blockCount = parseInt(root.getAttribute('data-block-count') || '0', 10);
    var enableControls = blockCount > 1;

    preloadEssentialImages(root);

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    var prevEl = root.querySelector('[data-ess-prev]');
    var nextEl = root.querySelector('[data-ess-next]');
    var paginationEl = root.querySelector('[data-ess-pagination]');

    var swiper = new Swiper(swiperEl, Object.assign({}, SWIPER_DRAG, {
      slidesPerView: 1.5,
      spaceBetween: 12,
      speed: 450,
      observer: true,
      observeParents: true,
      pagination:
        enableControls && paginationEl
          ? {
              el: paginationEl,
              clickable: true
            }
          : undefined,
      navigation:
        enableControls && prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl
            }
          : undefined,
      breakpoints: {
        750: {
          slidesPerView: 2.5,
          spaceBetween: 12
        },
        990: {
          slidesPerView: 3.2,
          spaceBetween: 12
        }
      }
    }));

    root._essSwiper = swiper;
  }

  function boot() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('[data-ess-section]').forEach(initEssentialsWithinReach);
  }

  function waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (typeof Swiper !== 'undefined' || ++tries > 40) {
        clearInterval(timer);
        if (typeof Swiper !== 'undefined') callback();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(boot);
    });
  } else {
    waitForSwiper(boot);
  }

  document.addEventListener('shopify:section:load', function (e) {
    waitForSwiper(function () {
      var root = document.getElementById('ess-' + e.detail.sectionId);
      if (root) {
        root.dataset.essInit = 'false';
        initEssentialsWithinReach(root);
      }
    });
  });
})();
